import React from "react";
import HeaderOne from "../HeaderOne/Main";
import BannerOne from "../Menhomeone/BannerOne";
import FeaturesOne from "../Menhomeone/FeaturesOne";
import AboutOne from "../Menhomeone/AboutOne";
import ServiceOne from "../Menhomeone/ServiceOne";
import TestimonialOne from "../Menhomeone/TestimonialOne";
import JoinUsOne from "../Menhomeone/JoinUsOne";
import BlogOne from "../Menhomeone/BlogOne";
import FooterOne from "../FooterOne/Main";

function Index() {

  return (
    <div>
      <HeaderOne />
      <div className="main-wrapper">
        <div className="data-scroll">
          <div className="page-wrapper">
            <main>
              <BannerOne />
              <FeaturesOne />
              <AboutOne />
              <ServiceOne />
              <TestimonialOne />
              <JoinUsOne />
              <BlogOne />
            </main>
            <FooterOne />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Index;
